
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../shared/services/auth.service';
@Injectable({
  providedIn: 'root'
})
export class PaymentService {

  constructor( 
    private http: HttpClient ,
    private auth: AuthService
    ) {}

  async klarnaInitiateSession(body){
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    
    return this.http.post(`${environment.api_url}payment/sessions`, body, httpOptions).toPromise()
  }

  async klarnaAuthoriseOrder(body, auth_token){
    console.log('auth_token: ',auth_token)
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    
    return this.http.post(`${environment.api_url}payment/authorizations/${auth_token}/order`, body, httpOptions).toPromise()
  }

  async klarnaCheckoutOrder(body){
    const token = await this.auth.getToken();
    let httpOptions = {
      headers: new HttpHeaders({
        'Authorization': `Bearer ${token}`
      })
    };
    
    return this.http.post(`${environment.api_url}payment/orders`, body, httpOptions).toPromise()
  }
} 